import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getWeeklyReading, fetchPassages } from "../utils/weeklyReading";
import PortionCommentary from "./PortionCommentary";
import PortionOthersCommentary from "./PortionOthersCommentary";

function TorahPortion({ loggedIn }) {
  const [loading, setLoading] = useState(true);
  const [portionName, setPortionName] = useState("");
  const [portionHebrew, setPortionHebrew] = useState("");
  const [portionRef, setPortionRef] = useState("");
  const [portionText, setPortionText] = useState("");
  const [error, setError] = useState("");
  const [isFestival, setIsFestival] = useState(false);
  const [maftirRef, setMaftirRef] = useState("");
  const [maftirText, setMaftirText] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        const reading = await getWeeklyReading();
        if (!reading || reading.torahIds.length === 0) {
          setError("Could not detect current Torah portion.");
          return;
        }

        setPortionName(reading.name);
        setPortionHebrew(reading.hebrew);
        setPortionRef(reading.torahRef);
        setIsFestival(reading.isFestival);
        setMaftirRef(reading.maftirRef);

        const [text, maftir] = await Promise.all([
          fetchPassages(reading.torahIds),
          reading.maftirIds.length ? fetchPassages(reading.maftirIds) : Promise.resolve(""),
        ]);
        setPortionText(text);
        setMaftirText(maftir);
      } catch (err) {
        console.error("Error fetching Torah portion:", err);
        setError("An error occurred while loading the Torah portion.");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) return <p className="mediumtext" style={{ paddingTop: "60px" }}>Loading Torah Portion...</p>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <br /><br />
      <h2>{isFestival ? "Festival Torah Reading" : "Torah Portion of the Week"}</h2>
      <h4>{isFestival ? portionName : `Parashat ${portionName}`}{portionHebrew && ` | ${portionHebrew}`}</h4>
      <h5>{portionRef}</h5>
      <h6>
        {new Date().toLocaleDateString("en-us", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </h6>
      <div className="bible-chapters-buttons">
        <div className="bible-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(portionText) }} />
        {maftirText && (
          <>
            <h4>Maftir | {maftirRef}</h4>
            <div className="bible-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(maftirText) }} />
          </>
        )}
      </div>
      <br /><br />

      {loggedIn ? (
        <>
          <PortionCommentary collectionName="torahCommentaries" portionName={portionName} />
          <PortionOthersCommentary collectionName="torahCommentaries" portionName={portionName} />
        </>
      ) : (
        <Link to="/login">
          <div style={{ margin: "0 20px" }}>
            <button className="login-button">
              Login to Post Commentary or See Others' Commentary
            </button>
          </div>
        </Link>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({ loggedIn: state.loggedIn });

export default connect(mapStateToProps, {})(TorahPortion);
